import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {GLOBAL} from './global.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Article, ArticleFilter, FilterContainer, UpdatePriceArticle} from '../models/article';
import {Preference} from '../models/preference';
import {getArticlePrice, toShowMoney} from '../utils/utils';
import {ResponseDTO} from '../models/general/response';
import {BehaviorSubject} from 'rxjs';
import {CartItem} from '../classes/cart-item';

@Injectable({providedIn: 'root'})
export class ArticleService {
  private readonly url = `${GLOBAL.url}itemService`;
  private readonly storage = 'articleFilters';
  constructor(private _http: HttpClient) {
  }

  getArticles(page: number, article: Article) {
    let params: HttpParams = new HttpParams();
    if (article.name) {
      params = params.set('name', article.name);
    }
    params = params.set('ecommerceAvailable', 'true');
    params = params.set('available', 'true');

    if (article.departmentId != null && article.departmentId > 0) {
      params = params.set('departmentId', article.departmentId.toString());
    }

    return this._http.get<ResponseDTO<Article>>(`${this.url}/listSearch/${page}`, {params});
  }

  getArticle(sku, depositId: number) {
    let params: HttpParams = new HttpParams();
    if (depositId != null) {
      params = params.set('depositId', depositId.toString());
    }
    return this._http.get<Article>(`${this.url}/${sku}`, {params});
  }

  getPrice(article: Article, list: number) {
    return getArticlePrice(article, list);
  }

  getArticleName(article: Article): string {
    return article.description ? `${article.name} ${article.description}` : article.name;
  }

  getPriceToShow(price) {
    return toShowMoney(price);
  }

  setStorage(filter: FilterContainer) {
    return localStorage.setItem(this.storage, JSON.stringify(filter));
  }

  getStorage() {
    const filter = localStorage.getItem(this.storage);
    return (filter) ? JSON.parse(filter) : null;
  }

  /**
   * Obtiene artículos por lista de SKUs
   * Útil para cargar productos del carrito
   */
  getArticlesBySku(skus: string[]) {
    return this._http.post<Article[]>(`${this.url}/by-skus`, skus);
  }
}
